<template>
  <transition name="fade">
    <section class="info" v-if="show">
      <img
        src="../images/utils/close.svg"
        alt="Закрыть"
        class="info__hide"
        @click="hideSelf"
      />
      <h2 class="info__title">
        С Новым 2022 Годом!
        <br />Рады сообщить вам о режиме работы клуба в праздничные дни <br />
        <span
          >31 декабря - с 8:00 до 18:00 <br />1 января - выходной день <br />2-9
          января - с 08:00 до 24:00</span
        >
        <br />Мы работаем для вас! <br />Успехов вам в Новом Году!
      </h2>
    </section>
  </transition>
</template>

<script>
export default {
  name: "block-info",
  data() {
    return {
      show: true,
    };
  },
  methods: {
    hideSelf() {
      this.show = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/constants.scss";

.info {
  position: fixed;
  left: 1vw;
  bottom: 1vw;
  max-width: 300px;
  padding: 30px;
  background-color: $primary;
  z-index: 99;

  &__hide {
    width: 20px;
    height: 20px;
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
  }

  &__title {
    font-size: 14px;
    line-height: 20px;
    color: #fff;
    text-align: center;
    font-weight: normal;

    span {
      font-weight: bold;
    }
  }
}

@media (max-width: 640px) {
  .info {
    max-width: 100%;
    right: 1vw;
    padding: 30px 20px;

    &__title {
      font-size: 12px;
      line-height: 17px;
    }
  }
}
</style>